module.exports = __webpack_public_path__ + "static/media/arrow-return.06986a62.svg";